module.exports = __webpack_public_path__ + "assets/img/QRlogoC.636e213161465e9c8eb346124f097ea4.svg";